export interface ProgressBarProps {
  value: number; // 0-100
  label?: string;
  showPercentage?: boolean;
}

export function ProgressBar({ value, label, showPercentage = true }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div className="progress-bar-container">
      {label && <span className="progress-label">{label}</span>}
      <div
        className="progress-bar"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label || 'Progress'}
      >
        <div className="progress-bar-fill" style={{ width: `${clamped}%` }} />
      </div>
      {showPercentage && <span className="progress-percentage">{Math.round(clamped)}%</span>}
    </div>
  );
}

export default ProgressBar;
